import React, { forwardRef } from 'react';
import { Link } from 'react-router-dom';
import MuiLink from '@mui/material/Link';
import PropTypes from 'prop-types';

export const VpLink = ({ href = '', to = '', newTab = false, children, ...rest }) => {
  // this component is working, but need to fix console errors
  const linkProps = {
    ...(newTab
      ? {
          target: '_blank',
          rel: 'noreferrer noopener'
        }
      : {})
  };

  if (href) {
    return (
      <MuiLink href={href} {...linkProps} {...rest}>
        {children}
      </MuiLink>
    );
  }
  return (
    <MuiLink // eslint-disable-next-line react/display-name
      component={forwardRef((props, ref) => (
        <Link innerRef={ref} {...props} />
      ))}
      to={to}
      {...rest}
    >
      {children}
    </MuiLink>
  );
};

VpLink.propTypes = {
  newTab: PropTypes.bool,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  href: PropTypes.string,
  children: PropTypes.node
};

export default VpLink;



// WEBPACK FOOTER //
// ./src/vp-ui/components/VpLink.jsx